import { clsx } from 'clsx';
import { useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';

import { useGetGoodTariffsData } from '@/api';
import { QuestionMarkIcon } from '@/components/icons/input';
import { Tooltip } from '@/components/shared/Tooltip/Tooltip.tsx';
import { useFilterStore } from '@/store';

import cn from './styles.module.sass';

export const DeviceType = () => {
    const { deviceTypes, setDeviceTypes, setSearchParams } = useFilterStore();
    const { data, isLoading } = useGetGoodTariffsData();
    const [isTooltipShown, setIsTooltipShown] = useState(false);

    const handleClick = (id: number) => {
        const targetDeviceType = deviceTypes?.find(deviceType => deviceType.id === id);
        if (targetDeviceType && deviceTypes) {
            const updatedDeviceType = {
                ...targetDeviceType,
                active: !targetDeviceType.active,
            };
            const newDeviceTypes = deviceTypes.map(deviceType =>
                deviceType.id === id ? updatedDeviceType : deviceType
            );

            setDeviceTypes(newDeviceTypes);

            const activeDeviceTypesIds = newDeviceTypes
                .filter(deviceType => deviceType.active)
                .map(deviceType => deviceType.id);
            setSearchParams({ device: activeDeviceTypesIds });
        }
    };

    useEffect(() => {
        if (data?.deviceTypes) {
            const deviceTypesWithStatuses = data.deviceTypes.map(type => ({
                ...type,
                active: false,
            }));
            setDeviceTypes(deviceTypesWithStatuses);
        }
    }, [data?.deviceTypes]);

    return (
        <div className={cn.deviceTypes}>
            {isLoading ? (
                <Skeleton
                    height={32}
                    width={117}
                    count={2}
                    containerClassName={cn.devicesSkeletonContainer}
                />
            ) : (
                deviceTypes?.map(type => {
                    return (
                        <div
                            onClick={handleClick.bind(null, type.id)}
                            key={type.id}
                            className={clsx(cn.deviceTypeItem, type.active && cn.active)}
                        >
                            {type.name}
                        </div>
                    );
                })
            )}
            <span onClick={() => setIsTooltipShown(!isTooltipShown)} className={cn.qMarkIcon}>
                {QuestionMarkIcon}
            </span>
            {isTooltipShown && (
                <Tooltip
                    className={cn.tooltip}
                    text="Для умных устройств, которым нужна SIM-карта, но не нужны минуты (планшеты, часы и т.п.)"
                />
            )}
        </div>
    );
};
